import { makeStyles, type Theme } from '@material-ui/core/styles';

const drawerWidth = 230;

const useStyles = makeStyles((theme: Theme) => ({
	header: {
		padding: theme.spacing(2, 3),
		borderRadius: 8,
		'& > h1': {
			fontSize: 24,
			fontWeight: 'bold',
			color: '#242C37',
			marginBottom: 16,
		},
		'& > h3': {
			fontSize: 18,
			fontWeight: 500,
			color: '#242C37',
		},
		'& > h5': {
			fontSize: 18,
			fontWeight: 500,
			color: '#242C37',
			marginTop: 8,
			'& > strong': {
				marginLeft: 8,
			},
		},
	},
	passedCard: {
		border: '1px solid #6CC397',
		background: 'rgba(29, 170, 108, 0.04)',
	},
	notPassedCard: {
		border: '1px solid #DE6E2D',
		background: '#FFF5EB',
	},
	passsedColor: {
		color: '#1DAA6C',
		marginLeft: 8,
	},
	notPassedColor: {
		color: '#DE6E2D',
		marginLeft: 8,
	},
	stepsContainer: {
		'& .MuiStepIcon-completed': {
			color: theme.palette.secondary.main,
		},
	},
	activeSection: {
		color: theme.palette.secondary.main + '!important',
		cursor: 'pointer',
	},
	questionCard: {
		padding: '16px 24px',
	},
	buttons: {
		width: '100%',
		padding: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	divider: {
		width: '100%',
		margin: '16px 0px',
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		paddingTop: 64,
		[theme.breakpoints.down('md')]: {
			paddingTop: 24,
		},
	},
	label: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 500,
		color: '#000',
		'& > svg': {
			marginLeft: 8,
			height: 16,
			width: 16,
		},
	},
	labelCorrectSelected: {
		color: '#1DAA6C',
		fontWeight: 'bold',
		'& > svg': {
			fill: '#1DAA6C',
		},
	},
	labelIncorrectSelected: {
		color: theme.palette.error.main,
		fontWeight: 'bold',
		'& > svg': {
			fill: theme.palette.error.main + ' !important',
		},
	},
	labelCorrectNoSelected: {
		color: '#0073e6',
		fontWeight: 'bold',
		'& > svg': {
			fill: '#0073e6',
		},
	},
	disabledRadio: {
		color: theme.palette.secondary.main + ' !important',
		'& svg': {
			fill: theme.palette.secondary.main + ' !important',
		},
	},
	saveContainer: {
		width: '100%',
		padding: 16,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	downloadButtonContainer: {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
		// '& svg': {
		//     fill: theme.palette.secondary.main
		// }
	},
}));

export default useStyles;
